let utils = require( './utils' );

let sidebar_menu = (function( $ ) {

	let anim_speed = 400,
		$sidebar = null;

	let _init = function() {
		$sidebar = $( '#sidebar-nav' );

		if ( $sidebar.length > 0 ) {
			_setup_submenu_toggles();

			if ( utils.viewport_size().width < 992 ) {
				$sidebar.find( '.header' ).on( 'click', _open_menu );
			}
		}
	};

	let _setup_submenu_toggles = function() {
		$sidebar.find( 'li.current-menu-parent' ).addClass( 'open' );

		$sidebar.find( 'li.menu-item-has-children > a' ).on( 'click', function( e ) {
			e.preventDefault();

			let $li         = $( this ).closest( 'li' ),
				type        = $li.hasClass( 'open' ) ? 'close' : 'open';

			if ( type === 'open' ) {
				let should_wait = _close_open_submenus( $li );

				if ( should_wait ) {
					setTimeout( () => {
						_toggle_submenu( $li );
					}, anim_speed );
				} else {
					_toggle_submenu( $li );
				}
			} else {
				_toggle_submenu( $li );
			}
		} );
	};

	let _toggle_submenu = function( $parent ) {
		if ( $parent.hasClass( 'animating' ) ) {
			return;
		}

		$parent.addClass( 'animating' );

		if ( $parent.hasClass( 'open' ) ) {
			_close_submenu( $parent );
		} else {
			_open_submenu( $parent );
		}

		setTimeout( function() {
			$parent.removeClass( 'animating' );
		}, 400 )
	};

	let _open_submenu = function ( $parent ) {
		$parent.find( '.sub-menu' ).slideDown( anim_speed );
		$parent.removeClass( 'closed' );
		$parent.addClass( 'open' );
	};

	let _close_submenu = function( $parent ) {
		$parent.find( '.sub-menu' ).slideUp( anim_speed );
		$parent.removeClass( 'open' );
		$parent.addClass( 'closed' );
	};

	let _close_open_submenus = function( $exclude = false ) {
		let $parents = $sidebar.find( 'li.open' ).not( '.current-menu-parent' );

		if ( $exclude ) {
			$parents.not( $exclude.get( 0 ) );
		}

		if ( $parents.length > 0 ) {
			_close_submenu( $parents );

			return true;
		}

		return false;
	};

	let _open_menu = function( event ) {
		$sidebar.toggleClass( 'expanded' );
		$sidebar.find( '.menu-container' ).slideToggle();

		event.preventDefault();
	};

	if ( $( '#sidebar-nav' ).length > 0 ) {
		$( window ).ready( _init );
	}

	return {}

})( jQuery );

module.exports = sidebar_menu;